import i18next from 'i18next';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {logout} from '../../state/auth';
import Overlay from '../Overlay';
import Popup from '../Popup';

import styles from './index.module.css';
import Navbar from 'components/Navbar';
import Header from 'components/Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({children}) => {
  const dispatch = useDispatch();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  return (
    <>
      <Navbar 
        requestLogout={() => setShowLogoutModal(true)}
        isMobileOpen={isMobileNavOpen}
        onMobileClose={() => setIsMobileNavOpen(false)}
      />
      <div className={styles.content}>
        <button 
          className={`${styles.hamburger} ${isMobileNavOpen ? styles.hamburgerHidden : ''}`}
          onClick={() => setIsMobileNavOpen(true)}
          aria-label="Open menu"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 12H21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M3 6H21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M3 18H21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <Header isMobileMenuOpen={isMobileNavOpen} />
        {children}
      </div>
      {isMobileNavOpen && (
        <div 
          className={styles.mobileOverlay}
          onClick={() => setIsMobileNavOpen(false)}
        />
      )}
      {showLogoutModal && (
        <Overlay>
          <Popup
            title={i18next.t('common.logout')}
            actions={[
              {
                label: i18next.t('common.yes'),
                callback: () => dispatch(logout()),
              },
              {
                label: i18next.t('common.no'),
                callback: () => setShowLogoutModal(false),
              },
            ]}
            message={i18next.t('common.confirmLogout')}
          />
        </Overlay>
      )}
    </>
  );
};

export default Layout;
